"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module makeOriginalClass
 *
 * @description
 *
 * Preserve `className` as it was passed.
 * Without this maker the original class would be lost.
 *
 * This maker is independent of the value of `block`.
 *
 * *This maker is always applied.*
 *
 * @example
 *
 * import * as pluginOriginalClass from 'dumb-bem/lib/plugins/makeOriginalClass'
 *
 * pluginOriginalClass.maker('block', { className: 'btn btn-lg btn-success' }, {})
 *   // => 'btn btn-lg btn-success'
 *
 */
var maker = exports.maker = function maker(block, _ref, options) {
  var className = _ref.className;
  return className;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/plugins/makeOriginalClass.js
// module id = 1172
// module chunks = 0